<template>
  <div></div>
</template>

<script>
import Web3 from 'web3';
import {
  BSC_CHAIN_PARAMS,
  MARKET_ABI,
  MH_NFT_ABI,
  MBB_NFT_ABI,
  MG_TOKEN_ABI,
  getNFTAddress,
  getChainParams,
  getContracts
} from '../../assets/js/config';
import {foxLogin, getFoxNonce} from '../../assets/api/public';

// const web3 = new Web3(Web3.givenProvider || `${location.protocol}}//${location.host}`);
const web3 = new Web3(Web3.givenProvider || 'http://192.168.1.99:9329');
// let web3 = Web3 || undefined;
// ContractABI
// const contractAddress = '0xe8d06113a84f53825cdc293e974245a519a0e87b';
//
// const MyContract = new web3.eth.Contract(ABI, contractAddress);
const gasLimit = 3000000;
const gasPrice = web3.eth.gasPrice;
let options = {
  'gasPrice': gasPrice,
  'gas': gasLimit
}
// bsc MainNet
const BSCChainParams = BSC_CHAIN_PARAMS;

export default {
  name: 'metaMask-trade',
  data() {
    return {
      nftAddress: {

      },
      chainParams: {

      },
      mhNftContract: null,
      mbbNftContract: null,
      marketContract: null,
      mgTokenContract: null,
      muContract: null,
      gameContract: null
    };
  },
  mounted() {
    // this.nftAddress = getNFTAddress();
    // this.chainParams = getChainParams();
    console.log('--MetaMaskTrade--mounted---');
  },
  methods: {
    async init(callback, self) {
      let scope = this;
      this.getContractsAndAddress();
      this.chainParams = getChainParams();
      console.log('----init----',  scope.chainParams)
      if (window.ethereum) {
        try {
          // const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
          window.ethereum.sendAsync({method: 'eth_requestAccounts'}, function(err, response) {
              if (err) {
                  console.log('----sendAsync---', err.code);
                  if (err.code == 4001) {
                    self.$notify.error({
                      title: 'Failed',
                      message: 'Login failed.'
                    });
                  }
              } else {
                  const account = response.result[0];
                  window.ethereum.sendAsync({method: 'eth_chainId'}, function(err, response) {
                      // if (response.result === '0x61') {
                      console.log('----sendAsync eth_chainId----', response, scope.chainParams.chainId)
                      if (response.result != scope.chainParams.chainId) {
                          window.ethereum.sendAsync({method: 'wallet_switchEthereumChain', params:[{'chainId': scope.chainParams.chainId}]}, function(err, response) {
                              if (!err) {
                                scope.checkLogin(scope, self, callback);
                                // scope.checkLogin(coinbase, scope, callback);
                              } else {
                                  if (err.code == 4902) {
                                      window.ethereum.sendAsync({method: 'wallet_addEthereumChain', params: scope.chainParams}, function(err, response) {
                                          if (!err) {
                                            scope.checkLogin(scope, self, callback);
                                            // const coinbase = await scope.getCoinbase(scope);
                                            // scope.checkLogin(coinbase, scope, callback);
                                          }
                                      }.bind(self));
                                  }
                              }
                          }.bind(self));
                      } else {
                        scope.checkLogin(scope, self, callback);
                        // const coinbase = await scope.getCoinbase(scope);
                        // scope.checkLogin(coinbase, scope, callback);
                      }
                      console.log('---eth_chainId---', response.result);
                  }.bind(self));
              }
          }.bind(self));
          // listen to accountsChanged
          // window.ethereum.on('accountsChanged', async (nAccounts) => {
          //   alert('Account changed, please log in again');
          //   callback('', '', true)
          // });
          // // listen to chainChanged
          // window.ethereum.on('chainChanged', async (nAccounts) => {
          //   alert('The network has changed. Please log in again');
          //   callback('', '', true)
          // });
        } catch (error) {
          console.log(error);
          // when user don't approve
        }
      } else {
        self.$notify.error({
          title: 'Failed',
          message: 'please install MetaMask!'
        });
      }
    },

    getContractsAndAddress(){
      this.getContracts();
      this.nftAddress = getNFTAddress();
    },

    getContracts(){
      let contracts = getContracts();
      console.log('-----getContracts----', contracts);
      this.mhNftContract = contracts.mhNftContract;
      this.mbbNftContract = contracts.mbbNftContract;
      this.marketContract = contracts.marketContract;
      this.mgTokenContract = contracts.mgTokenContract;
      this.muContract = contracts.muContract;
      this.gameContract = contracts.gameContract;
    },

    async getCoinbase(self, callback) {
      try {
        const coinbase =  await web3.eth.getCoinbase();
        if (!coinbase) {
          self.$notify.error({
            title: 'Failed',
            message: 'Please activate MetaMask first.'
          });
          return null;
        }
        return coinbase;
      } catch (addError) {
        return null;
      }
    },

    async checkLogin(scope, self, callback){
      try {
        const coinbase =  await web3.eth.getCoinbase();
        if (!coinbase) {
          self.$notify.error({
            title: 'Failed',
            message: 'Please activate MetaMask first.'
          });
          console.log('---checkLogin- coinbase null--');
          return;
        }
        const publicAddress = coinbase.toLowerCase();
        const {nonce} = await getFoxNonce(publicAddress);
        const signature = await scope.getSignature(nonce, publicAddress);
        if (!signature) return;
        const {token} = await scope.toLogin(publicAddress, signature);
        if (!token) return;
        localStorage.setItem('token', token);
        // const account = accounts[0];
        // 获取货币数量
        let balance = 0;
        // let balance = await window.ethereum.request({ method: 'eth_getBalance', params: [account] });
        // balance = web3.utils.hexToNumberString(balance); // change to number
        // balance = web3.utils.fromWei(balance, 'ether'); // format
        callback && callback(publicAddress, balance, false);
      } catch (err) {
        self.$notify.error({
          title: 'Failed',
          message: 'Please activate MetaMask first.'
        });
        console.log('---checkLogin- coinbase --', err);
        return;
      }
    },
    async switchEthereumChain() {
      // switchEthereumChain
      try {
        await window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: '0x38' }]
        });
      } catch (switchError) {
        // This error code indicates that the chain has not been added to MetaMask.
        if (switchError.code === 4902) {
          try {
            await window.ethereum.request({
              method: 'wallet_addEthereumChain',
              params: BSCChainParams
            });
          } catch (addError) {
            // handle 'add' error
          }
        }
        // handle other 'switch' errors
      }
    },
    async getAccounts() {
      try {
        const accounts = await web3.eth.getAccounts();
        return accounts.length > 0 ? accounts[0] : null;
      } catch (addError) {
        return null;
      }
    },
    //toLogin
    async toLogin(address, sign) {
      try {
        return await foxLogin({address, sign})
      } catch (err) {
        console.log(err)
      }
    },
    // getSignature
    async getSignature(nonce, publicAddress) {
      try {
        return await web3.eth.personal.sign(
            nonce,
            publicAddress // MetaMask will ignore the password argument here
        );
      } catch (err) {
        this.$notify.error({
          title: 'err',
          message: 'Please authorize'
        })
      }
    },
    // getBalance
    async getBalance() {
      await this.isEnable((account) => {
        let fromAddress = account[0];
        web3.eth.getBalance(fromAddress, (err, res) => {
          if (!err) {
            console.log('balance:', res);
          }
        });
      });
    },
    async balanceOf(name) {
      const accounts = await web3.eth.getAccounts();
      const account = accounts[0];
      this.getContractsAndAddress();
      try {
        let result;
        if(name === 'mg'){
           result = await this.mgTokenContract.methods.balanceOf(account).call({ from: account });
        }else if(name === 'mu'){
          result = await this.muContract.methods.balanceOf(account).call({ from: account });
        }
        console.log('---balanceof----', result);
        return result;
      } catch (error) {
        console.log(error);
        return error;
      }
    },
    // sendTransaction
    async sendTransaction(toAccount) {
      await this.isEnable((account) => {
        let fromAddress = account[0];
        // web3 sendTransaction
        web3.eth
          .sendTransaction({
            from: fromAddress,
            to: toAccount,
            value: '10000000000000000'
          })
          .then((result) => {
            console.log(result);
          });
      });
    },
    // isEnable
    async isEnable(callback) {
      let account = await web3.eth.getAccounts();
      if (account.length > 0) {
        let fromAddress = account;
        callback && callback(fromAddress);
      } else {
        // request user approve
        await window.ethereum.enable();
      }
    },
    // isAddress
    async isAddress(address) {
      const accounts = await web3.eth.getAccounts();
      const account = accounts[0];
      this.getContractsAndAddress();
      try {
        let result = await web3.utils.isAddress(address);
        console.log('---isAddress----', result);
        return result;
      } catch (error) {
        console.log(error);
        return error;
      }
    },
    // approve for sell
    async sellApprove(type) {
      const accounts = await web3.eth.getAccounts();
      const account = accounts[0];
      this.getContractsAndAddress();
      try {
        let result;
        switch (type) {
          case 721:
            // sell for 721
            result = await this.mhNftContract.methods.setApprovalForAll(this.nftAddress.MARKET_ADDRESS, true).send({ from: account, gas: gasLimit });
            break;
          case 1155:
            result = await this.mbbNftContract.methods.setApprovalForAll(this.nftAddress.MARKET_ADDRESS, true).send({ from: account, gas: gasLimit });
            break;
          default:
            break;
        }
        return result;
      } catch (error) {
        console.log(error);
        return error;
      }
    },
    async createOrder(type, flag, feeFlag, assetId, amount, priceInWei, expiresAt, ts, orderId) {
      const accounts = await web3.eth.getAccounts();
      const account = accounts[0];
      this.getContractsAndAddress();
      console.log('------createOrder--params---', type, flag, feeFlag, assetId, amount, priceInWei, expiresAt, ts, orderId);
      try {
        let result;
        switch (type) {
          case 721:
            // sell for 721
            console.log('----createOrder--type--', type);
            result = await this.marketContract.methods.create721Order(ts, orderId, flag, feeFlag, assetId, priceInWei, expiresAt).send({ from: account, gas: gasLimit });
            break;
          case 1155:
            console.log('----createOrder--type--', type);
            result = await this.marketContract.methods.create1155Order(ts, orderId, flag, feeFlag, assetId, amount, priceInWei, expiresAt).send({ from: account, gas: gasLimit });
            break;
          default:
            break;
        }
        return result;
      } catch (error) {
        console.log(error);
        return error;
      }
    },
    async cancelOrder(type, ts, orderId) {
      const accounts = await web3.eth.getAccounts();
      const account = accounts[0];
      this.getContractsAndAddress();
      try {
        let result;
        switch (type) {
          case 721:
            // cancel for 721Order
            result = await this.marketContract.methods.cancel721Order(ts, orderId).send({ from: account, gas: gasLimit });
            break;
          case 1155:
            // result = await MarketContract.methods.cancel1155Order(ts, orderId, flag, assetId, adress).send({ from: account, gas: gasLimit });
            result = await this.marketContract.methods.cancel1155Order(ts, orderId).send({ from: account, gas: gasLimit });
            break;
          default:
            break;
        }
        return result;
      } catch (error) {
        console.log(error);
        return error;
      }
    },
    // buyApprove
    async buyApprove() {
      const accounts = await web3.eth.getAccounts();
      const account = accounts[0];
      this.getContractsAndAddress();
      try {
        const result = await this.mgTokenContract.methods.setApprovalForAll(this.nftAddress.MARKET_ADDRESS, true).send({ from: account, gas: gasLimit });
        return result;
      } catch (error) {
        console.log(error);
        return error;
      }
    },
    async boxBuyApprove() {
      const accounts = await web3.eth.getAccounts();
      const account = accounts[0];
      this.getContractsAndAddress();
      try {
        const result = await this.muContract.methods.setApprovalForAll(this.nftAddress.GAME_ADDRESS, true).send({ from: account, gas: gasLimit });
        return result;
      } catch (error) {
        console.log(error);
        return error;
      }
    },
    async executeOrder(type, ts, orderId) {
      const accounts = await web3.eth.getAccounts();
      const account = accounts[0];
      this.getContractsAndAddress();
      try {
        let result;
        switch (type) {
          case 721:
            // execute721Order
            // result = await MarketContract.methods.execute721Order(flag, feeFlag, assetId, price).send({ from: account, gas: gasLimit });
            result = await this.marketContract.methods.execute721Order(ts, orderId).send({ from: account, gas: gasLimit });
            break;
          case 1155:
            // result = await MarketContract.methods.execute1155Order(flag, feeFlag, assetId, address).send({ from: account, gas: gasLimit });
            result = await this.marketContract.methods.execute1155Order(ts, orderId).send({ from: account, gas: gasLimit });
            break;
          default:
            break;
        }
        return result;
      } catch (error) {
        console.log(error);
        return error;
      }
    },

    async buyItemByMu(ts, amount, v, r, s) {
        const accounts = await web3.eth.getAccounts();
        const account = accounts[0];
        this.getContractsAndAddress();
        v = web3.utils.hexToNumber('0x'+v);
        r = '0x'+ r;
        s = '0x'+ s;
        console.log('---buyItemByMu---muToItem---', ts, amount, v, r, s)
        try {
          const result = await this.gameContract.methods.muToItem(ts, amount, v, r, s).send({from: account, gas: gasLimit});
          return result;
        } catch (error) {
          console.log(error);
          return error;
        }
    },

    // transferFrom
    async transferFrom(to, tokenId, type, amount) {
      const accounts = await web3.eth.getAccounts();
      const account = accounts[0];
      this.getContractsAndAddress();
      try {
        let result;
        console.log('----transferFrom---', this.mhNftContract, to, tokenId, type, amount);
        switch (type) {
          case 721:
            // sell for 721
            result = await this.mhNftContract.methods.safeTransferFrom(account, to, tokenId).send({ from: account, gas: gasLimit });
            break;
          case 1155:
            console.log(account, to, 0, amount, '0x00');
            result = await this.mbbNftContract.methods.safeTransferFrom(account, to, 0, amount, '0x00').send({ from: account, gas: gasLimit });
            break;
          default:
            break;
        }
        return result;
      } catch (error) {
        console.log(error);
        return error;
      }
    }
  }
};
</script>

<style scoped></style>
